
import { baseUrl } from "./baseUrl";

export const loginAPI = `${baseUrl}/login`;
export const signupAPI = `${baseUrl}/register`;
export const forgotAPI = `${baseUrl}/forgotpassword`;
export const resetAPI = `${baseUrl}/reset-password`;